import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { ArrowButton } from 'src/components/shared/buttons'
import { MonoP, InternalLink, ExternalLink } from 'src/components/shared/text'
import { media, getScreenType } from 'src/utils/style-helper'

const HomeLink = styled(ExternalLink)`
  position: absolute;
  transform: translate(0, -50%);
  left: 0;
  z-index: 100;
  ${media.mobile`
    top: 17px;
  `}
  ${media.tablet`
    top: ${(props) => props.top};
  `}
`

const TextButton = styled(MonoP)`
  font-size: 16px;
  color: ${(props) => props.theme.colors.navy};
  &:hover {
    color: ${(props) => props.theme.colors.orange};
  }
`

const BigArrow = styled.span`
  font-size: 18px;
  padding-right: 6px;
`

const HomeButton = ({ top }) => {
  const isMobile = getScreenType() === 'mobile'
  return (
    <HomeLink to="https://petfinn.com/" top={top}>
      {isMobile ? (
        <ArrowButton left label="Home" />
      ) : (
        <TextButton>
          <BigArrow>￩</BigArrow>Home
        </TextButton>
      )}
    </HomeLink>
  )
}

HomeButton.propTypes = {
  top: PropTypes.string,
}

HomeButton.defaultProps = {
  top: '50%',
}

export default HomeButton
